import { createFrontendModule } from '@backstage/frontend-plugin-api';
import pagerDutyPlugin from '@pagerduty/backstage-plugin/alpha';
import { pagerDutyAdminPermission } from '@internal/hone-common';

export const pagerDutyModule = createFrontendModule({
  pluginId: 'pagerduty',
  extensions: [
    pagerDutyPlugin.getExtension('page:pagerduty').override({
      if: { permissions: { $contains: pagerDutyAdminPermission.name } },
    }),
  ],
});
